export default {"src":"/_next/static/media/argumentation-background.e8db29d2.svg","height":350,"width":3100};